import React from 'react'
import _ from 'lodash'
import moment from 'moment'
import ShowtimeScheduleWeek from './ShowtimeScheduleWeek'
import ShowtimeTypeList from './ShowtimeTypeList';

export default class ShowtimeSchedulev2 extends React.Component {

    constructor(props) {
        super(props);
        const { currentStartDate, movie } = this.props;
        const schedule = document.querySelector('.ShowtimeScheduleWeek');

        const showtimeTypes = [];
        const showtimesByDate = _.groupBy(movie.validShowtimes, (showtime) => {
            if (showtime.showInfo.enabled && showtime.type && !_.find(showtimeTypes, showtime.type))
                showtimeTypes.push(showtime.type);

            return moment(showtime.dateTime).format('YYYY-MM-DD');
        });

        let startDate = currentStartDate;
        if (!startDate && movie.validShowtimes.length > 0) startDate = moment(movie.validShowtimes[0].dateTime);

        this.state = {
            showtimesByDate,
            currentStartDate: startDate || moment(),
            showtimeTypes,
            weekNo: moment().week(),
            take: 7 //days in schedule
        }

        this.nextWeek = this.nextWeek.bind(this);
        this.previousWeek = this.previousWeek.bind(this);
        this.handleWindowResize = this.handleWindowResize.bind(this);
    }

    componentDidMount() {
        const schedule = document.querySelector('.ShowtimeScheduleWeek');
    
        window.addEventListener('resize', this.handleWindowResize);
       this.setState({ take: this.determineTakeFromScreenWidth() });
    }

    componentWillUnmount() {
        const schedule = document.querySelector('.ShowtimeScheduleWeek');

         window.removeEventListener('resize', this.handleWindowResize);
    }

    handleWindowResize = _.debounce(() => {
        const schedule = document.querySelector('.ShowtimeScheduleWeek');

        this.setState({ take: this.determineTakeFromScreenWidth() });
    }, 200)

    determineTakeFromScreenWidth() {
        const schedule = document.querySelector('.ShowtimeScheduleWeek');
        const scheduleWidth = Math.round(Math.min(schedule.scrollWidth, schedule.offsetWidth, schedule.clientWidth));
       
        const showtimeItem = document.querySelector('.showtimes-on-date');
       
        const showtimeItemWidth = Math.round(Math.max(showtimeItem.scrollWidth, showtimeItem.offsetWidth, showtimeItem.clientWidth));
   
        return Math.floor(scheduleWidth / showtimeItemWidth);
    }

    componentDidUpdate(prevProps) {
        const { movie, appLocale, currentStartDate } = this.props;
        //Update showtimes if another version of same movie is selected
        if (movie.id != prevProps.movie.id || appLocale != prevProps.appLocale)
            this.setState({ showtimesByDate: _.groupBy(movie.validShowtimes, (showtime) => moment(showtime.dateTime).format('YYYY-MM-DD')) });

        if (currentStartDate != prevProps.currentStartDate)
            this.setState({ currentStartDate });
    }

    anyInFuture(currentStartDate) {
        const { showtimesByDate, take } = this.state;
    

        const nextStartDate = currentStartDate.clone().add(take, 'days');
        return _.some(showtimesByDate, (showtimes, dateKey) => moment(dateKey).isSameOrAfter(nextStartDate, 'day'));
    }

    anyInPast(currentStartDate) {
        const { showtimesByDate } = this.state;
        return _.some(showtimesByDate, (showtimes, dateKey) => moment(dateKey).isBefore(currentStartDate, 'day'));
    }

    nextWeek() {
        const { currentStartDate, take, weekNo } = this.state;
        this.setState({ currentStartDate: currentStartDate.add(take, 'days') });
        this.setState({ weekNo: weekNo + 1 })

    }

    previousWeek() {
        const { currentStartDate, take, weekNo } = this.state;
        this.setState({ currentStartDate: currentStartDate.subtract(take, 'days') });
        this.setState({ weekNo: weekNo - 1 })

    }
   

    render() {
        const { currentStartDate, showtimesByDate, showtimeTypes, take } = this.state;
       
        const { filterIds, showExpired, showtimeClicked, appLocale, movie } = this.props;
      
        const disabled = 'week-nav disabled';
        const prevWeekClasses = this.anyInPast(currentStartDate) ? 'week-nav' : disabled;
        const nextWeekClasses = this.anyInFuture(currentStartDate) ? 'week-nav' : disabled;

        return (
            <div className="ShowtimeSchedule v2">
         
                <div className="schedule">
                   
                   
                    <ShowtimeScheduleWeek
                        currentStartDate={currentStartDate}
                        showtimesByDate={showtimesByDate}
                        appLocale={appLocale}
                        showExpired={showExpired}
                        showtimeClicked={showtimeClicked}
                        take={take}
                        movie={movie }
                    />
                    <div style={{height:'inherit',marginTop:'70px'} }>
                    <div className={nextWeekClasses} onClick={this.nextWeek}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="30" viewBox="0 0 18 30" fill="none">
                            <path d="M4.25 5L14.25 15L4.25 25" stroke="white" stroke-width="2" stroke-linecap="round" />
                        </svg>
                    </div>
                     <div className={prevWeekClasses} onClick={this.previousWeek}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="30" viewBox="0 0 18 30" fill="none">
                        <path d="M14.25 5L4.25 15L14.25 25" stroke="white" stroke-width="2" stroke-linecap="round" />
                        </svg>
                    </div>
                    </div>
                </div>

                {
                    window.location.href.includes('multibio-film-infov2') ?
                        ((!filterIds || filterIds.length > 1) && showtimeTypes.length > 0 && (movie.versions && movie.versions.length <= 0 || movie.versions.length === 1) ? <ShowtimeTypeList types={showtimeTypes} /> : null)
                        :
                        null
                }
                   
                
            </div>
        )
    }
}